import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { Brand } from "../brand";
import { EquipmentItem } from "../equipment/equipmentItem";
import { IEquipmentItemProps } from "../equipment/interfaces";
import { Center } from "../center";
import { IRepairCenterEquipment, IRepairCenterEquipmentProps, IRepairCenterEquipmentStates } from "./interfaces";
import { ICenterProps } from "../center/interfaces";

export class RepairCenterEquipment extends EntityManager<IRepairCenterEquipment, IRepairCenterEquipmentProps, IRepairCenterEquipmentStates>{
    static initMetadata = (): IMetadata => {
        return {
            title: "تجهیزات مجاز تعمیر",
            name: "RepairCenterEquipment",
            Properties: [
                {
                    title: "مرکز تعمیرات",
                    dataIndex: "RepairCenterId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا مرکز تعمیرات را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Center,
                        lookupProperty: "RepairCenter",
                        lookupDisplayFields: ["FullName"]
                    }
                },
                {
                    title: "تجهیز",
                    dataIndex: "EquipmentId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا تجهیز را وارد نمایید' }],
                    lookup: {
                        lookupComponent: EquipmentItem,
                        lookupProperty: "Equipment",
                        lookupDisplayFields: ["Name"]
                    }
                },
                {
                    title: "برند",
                    dataIndex: "BrandId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا برند را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Brand,
                        lookupProperty: "Brand",
                        lookupDisplayFields: ["Name"]
                    }
                }
            ]
        };
    }
    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;

        this.preparelookupProps = (propName, lookupProps: any) => {
            if (propName === "RepairCenterId")
                (lookupProps as ICenterProps).isRepairCenter = true;

            if (propName === "EquipmentId")
                (lookupProps as IEquipmentItemProps).params = () => {
                    return { onlySubItems: true }
                };
            return lookupProps;
        };

        this.originalFilter = () => {
            if (this.props.params && this.props.params()?.repairCenter) {
                return ComparisonFilter.Equal<IRepairCenterEquipment>(m => m.RepairCenterId, this.props.params && this.props.params()?.repairCenter?.Id);
            }
        };
        this.extraHeaderNodes = () => {
            return (
                <Descriptions className="header-page">
                    <Descriptions.Item label="مرکز تعمیرات">{this.props.params && this.props.params().repairCenter?.FullName}</Descriptions.Item>
                </Descriptions>
            );
        };
        this.onEntityAdded = (entity) => {
            let repairCenter = this.props.params && this.props.params().repairCenter
            if (repairCenter) {
                entity.RepairCenterId = repairCenter.Id;
                entity.RepairCenter = repairCenter;
                entity.ModifiedProperties.push("RepairCenterId");
            }
            return true;
        };
    }
}